
<div class="subheader with-padding flgrow">
    <div  class="row">
        <div class="col-lg-4 col-md-6 col-sm-8">
          <div class="flmid relative">
              <div class="input-group flgrow">
                  <input class="form-control" type="text" name="searchTerm" placeholder="{{ 'lblSearch' | translate }}"
                    [(ngModel)]="searchTerm" autocomplete="off" (keyup.enter)="onEnterPress()" />
                  <div class="input-group-append">
                    <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                      <em class="fa fa-search font17"></em>
                    </button>
                  </div>
                </div>
          </div>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6">
            <ng-select placeholder="{{ 'lblSelectChargingGroup' | translate }}" [(ngModel)]="chargingGroupNo"  (change)="ChargingGroupChange($event)">
              <ng-option *ngFor="let type of chargingGroupList">
                {{type.groupNo}}</ng-option>
            </ng-select>
        </div>
        <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
          <ng-select placeholder="{{ 'lblSelectLaborPriceGroup' | translate }}" [(ngModel)]="laborPriceGroup"  (change)="LaborPriceGroupChange($event)">
            <ng-option *ngFor="let type of laborAndItemSalesPriceList?.laborGroupPrice">
              {{type.code}}</ng-option>
          </ng-select>
        </div>
        
      </div>
</div>
<!-- Listing grid -->
<div class="container prel">
    <div class="row">
        <div class="c12">
            <div class="card mb-3">
                <div class="card-header d-flex justify-content-between" translate>
                    lblLaborChargingGroupPrice
                    <div class="font16 fontbold">
                        <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                        totalCount
                        }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                    </div>
                </div>
                <div class="table-responsive max-h232" infinite-scroll [infiniteScrollDistance]="scrollDistance"
                    [infiniteScrollThrottle]="throttle" [alwaysCallback]="true" [scrollWindow]="false"
                    (scrolled)="loadMoreData($event)">
                    <table class="tablest1">
                        <thead>
                            <tr>
                                <th style="width: 55px" scope="col">#</th>
                                <th style="width: 40px" scope="col" sortable="chargingGroup"
                                    (sort)="onSort($event)" translate>lblChargingGroup</th>
                                <th style="width: 40px" scope="col" sortable="laborPriceGroup" (sort)="onSort($event)"
                                    translate>lblLaborPriceGroup</th>
                                <th style="width: 40px" scope="col" translate>lblLaborChargingCode</th>
                                <th style="width: 40px" scope="col" sortable="dealerName" (sort)="onSort($event)" translate>lblDealer</th>
                                <th class="text-right" style="width: 40px" scope="col" translate>lblUnitPriceHours</th>
                                <th class="text-right" style="width: 40px" scope="col" translate>lblDiscount</th>
                                <th  style="width: 40px" scope="col" translate></th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngIf="laborChargingList?.length>0; else load_else">
                                <tr *ngFor="let itemPrice of laborChargingList; let i=index">
                                    <td>{{i+1}}</td>
                                    <td>{{itemPrice.chargingGroup}} - {{itemPrice.chargingGroupName}}</td>
                                    <td>{{itemPrice.laborPriceGroup ? itemPrice.laborPriceGroup : '-'}}</td>
                                    <td>{{itemPrice.laborChargingCode ? itemPrice.laborChargingCode : '-'}}</td>
                                    <td *ngIf="itemPrice.code == null && itemPrice.dealerName == null"> - </td>
                                    <td *ngIf="itemPrice.code != null && itemPrice.dealerName != null">{{itemPrice.code}} - {{itemPrice.dealerName}}</td>
                                    <td align="right">{{itemPrice.unitPriceHour | number: '1.2-2'}}</td>
                                    <td align="right">{{itemPrice.discount | number: '1.2-2'}}</td>
                                    <td></td>
                                </tr>
                            </ng-container>
                            <ng-template #load_else>
                                <tr>
                                    <td colspan="9" class="no-record" translate>lblNoRecordsFound</td>
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>

</div>
   